/**
 * Session-scoped dismissal for the "missing permissions" modal
 * (ModalVerifyIntegrationScopes).
 *
 * The modal is re-evaluated every time the `integrations` Redux object changes
 * reference — which happens on each Redux write while navigating — and the
 * component can remount. A component flag would therefore let the modal pop
 * again right after the user closes it. Keeping the dismissal out of component
 * state (in memory, per page load) is exactly the intended behavior: warn once
 * per page load, and warn again for a different user taking over the session
 * (e.g. "login as client"). It is intentionally not persisted anywhere, so a
 * page reload brings the warning back.
 */

let sessionDismissal = null;

/** True when the current user already closed the modal in this page load. */
export const isVerifyScopesDismissedInSession = ({ uid }) =>
  sessionDismissal !== null &&
  (sessionDismissal.uid === null || sessionDismissal.uid === (uid ?? null));

/** Records that the current user closed the modal in this page load. */
export const markVerifyScopesDismissedInSession = ({ uid }) => {
  sessionDismissal = { uid: uid ?? null };
};

/** Test helper: forgets the in-memory dismissal. */
export const resetVerifyScopesSessionDismissal = () => {
  sessionDismissal = null;
};
